"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M14.458 12c0 1.353-1.1 2.45-2.456 2.45A2.453 2.453 0 019.545 12c0-1.353 1.1-2.45 2.457-2.45A2.453 2.453 0 0114.458 12z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12c2.323-3.607 6.382-6 11.002-6 4.62 0 8.675 2.393 11.001 6a13.072 13.072 0 01-11.001 6C7.382 18 3.323 15.607 1 12zm6.878 0a4.117 4.117 0 004.124 4.112A4.119 4.119 0 0016.126 12a4.117 4.117 0 00-4.124-4.112A4.117 4.117 0 007.878 12z" })), "Preview");
//# sourceMappingURL=Preview.js.map